// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "productionXy/css/" + chunkId + ".1781681860623.css";
};